"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse32BitImage = parse32BitImage;
exports.parseCompressedImage = parseCompressedImage;
exports.parseImage = parseImage;
exports.writeImage = writeImage;
exports.writeImage24Bits = writeImage24Bits;
exports.writeImageIndexedColors = writeImageIndexedColors;

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This file contains functions used to parse images found in watchface bin files
 */
var HEADER_SIZE = 16;
/**
 * 
 * @param {ArrayBuffer} dataBuffer Binary data of a bitmap image
 * @returns {{width: number, height: number, pixels: Uint8ClampedArray, bitsPerPixel: number}} Object containing width height and pixel data in rgba form
 */

function parseImage(dataBuffer) {
  var dataView = new DataView(dataBuffer); // Check signature

  var signature = dataView.getUint16(0);

  if (signature !== 0x424D) {
    throw new Error("Invalid image signature: ".concat(signature.toString(16).padStart(2, '0')));
  } // read header


  var pixelFormat = dataView.getUint16(2, true);

  if (pixelFormat === 0x65) {
    return parseCompressedImage(dataBuffer);
  } else if (pixelFormat === 0xFFFF) {
    return parse32BitImage(dataBuffer);
  }

  var width = dataView.getUint16(4, true);
  var height = dataView.getUint16(6, true);
  var rowSize = dataView.getUint16(8, true);
  var bitsPerPixel = dataView.getUint16(10, true);
  var paletteColorsCount = dataView.getUint16(12, true);
  var transparentPaletteColor = dataView.getUint16(14, true);

  if (!([16, 24, 32].includes(bitsPerPixel) && paletteColorsCount === 0 && [0x08, 0x13, 0x1B, 0x1C, 0x10, 0x09].includes(pixelFormat)) && !([1, 2, 4, 8].includes(bitsPerPixel) && paletteColorsCount > 0 && pixelFormat === 0x64)) {
    throw new Error("Unsuported pixel format/color depth/Palette (should add support) ".concat(pixelFormat.toString(16), " ").concat(bitsPerPixel, "  ").concat(paletteColorsCount));
  }

  if (Math.ceil(bitsPerPixel * width / 8) !== rowSize) {
    throw new Error("Row size is not as expected (Padding ?)");
  }

  var paletteSize = 0;
  var palette = [];

  if (paletteColorsCount > 0) {
    // Read palette
    for (var i = 0; i < paletteColorsCount; i++) {
      var color = {
        red: dataView.getUint8(HEADER_SIZE + i * 4),
        green: dataView.getUint8(HEADER_SIZE + i * 4 + 1),
        blue: dataView.getUint8(HEADER_SIZE + i * 4 + 2),
        alpha: i === transparentPaletteColor - 1 ? 0xFF : 0x00
      };
      palette.push(color);
    }

    paletteSize = paletteColorsCount * 4;
  } // Read pixel data


  var pixels = new Uint8ClampedArray(4 * width * height);

  for (var y = 0; y < height; y++) {
    for (var x = 0; x < width; x++) {
      // read pixel color info
      var red = void 0;
      var green = void 0;
      var blue = void 0;
      var alpha = 0x00;

      if (paletteColorsCount) {
        var colorId = void 0;

        if (bitsPerPixel < 8) {
          var pixelsPerByte = 8 / bitsPerPixel;

          var _byte = dataView.getUint8(HEADER_SIZE + paletteSize + y * rowSize + Math.floor(x / pixelsPerByte));

          var bitMask = (1 << bitsPerPixel) - 1;
          var bitPosition = 8 - (x % pixelsPerByte + 1) * bitsPerPixel;
          colorId = _byte >> bitPosition & bitMask;
        } else {
          colorId = dataView.getUint8(HEADER_SIZE + paletteSize + y * rowSize + x);
        }

        var _color = palette[colorId];
        red = _color.red;
        green = _color.green;
        blue = _color.blue;
        alpha = _color.alpha;
      } else {
        var bytePerPixel = bitsPerPixel / 8;
        var pixelPosition = HEADER_SIZE + y * rowSize + x * bytePerPixel;

        if (bytePerPixel === 4) {
          red = dataView.getUint8(pixelPosition);
          green = dataView.getUint8(pixelPosition + 1);
          blue = dataView.getUint8(pixelPosition + 2);
          alpha = dataView.getUint8(pixelPosition + 3);
        } else {
          var rgba = void 0;

          if (bytePerPixel === 3) {
            // 24 bits is 16 bit color data (big endian) with 8 bit alpha
            alpha = dataView.getUint8(pixelPosition);
            rgba = dataView.getUint16(pixelPosition + 1, false);
          } else {
            // for the 16 bit images, the value is little endian
            rgba = dataView.getUint16(pixelPosition, true);
          }

          if (pixelFormat === 0x13) {
            // color is 16 bit (4:4:4:4) abgr
            alpha = (rgba & 0xF000) >> 8;
            blue = (rgba & 0x0F00) >> 4;
            green = rgba & 0x00F0;
            red = (rgba & 0x000F) << 4;
          } else if (pixelFormat === 0x1C || pixelFormat === 0x09) {
            // color is 16bit (5:6:5) rgb
            red = (rgba & 0xF800) >> 8;
            green = (rgba & 0x07E0) >> 3;
            blue = (rgba & 0x001F) << 3;
          } else {
            // color is 16bit (5:6:5) bgr
            blue = (rgba & 0xF800) >> 8;
            green = (rgba & 0x07E0) >> 3;
            red = (rgba & 0x001F) << 3;
          }
        }
      }

      var pixelPositionInResultArray = (y * width + x) * 4;
      pixels[pixelPositionInResultArray] = red;
      pixels[pixelPositionInResultArray + 1] = green;
      pixels[pixelPositionInResultArray + 2] = blue; // Alpha is inverted, 0xFF is transparent

      pixels[pixelPositionInResultArray + 3] = 0xFF - alpha;
    }
  }

  return {
    pixels: pixels,
    width: width,
    height: height,
    bitsPerPixel: bitsPerPixel,
    pixelFormat: pixelFormat
  };
}

function parse32BitImage(dataBuffer) {
  var dataView = new DataView(dataBuffer); // Check signature

  if (dataView.getUint16(0) !== 0x424D) {
    throw new Error("Invalid image signature: ".concat(dataView.getUint16(0).toString(16).padStart(2, '0')));
  } // read header


  var pixelFormat = dataView.getUint16(2, true);
  var width = dataView.getUint32(4, true);
  var height = dataView.getUint32(8, true);
  var bitsPerPixel = dataView.getUint32(12, true);
  var colorDepth = dataView.getUint32(16, true);
  var unknown = dataView.getUint16(20, true);

  if (!([32].includes(bitsPerPixel) && [0xFFFF].includes(pixelFormat) && [24].includes(colorDepth))) {
    throw new Error("Unsuported pixel format/bitsPerPixel (should add support) ".concat(pixelFormat.toString(16), " ").concat(bitsPerPixel));
  } // Read pixel data


  var pixels = new Uint8ClampedArray(4 * width * height);

  for (var y = 0; y < height; y++) {
    for (var x = 0; x < width; x++) {
      // read pixel color info
      var red = void 0;
      var green = void 0;
      var blue = void 0;
      var alpha = 0xFF;
      var bytePerPixel = bitsPerPixel / 8;
      var pixelPosition = 24 + y * width * 4 + x * bytePerPixel;
      red = dataView.getUint8(pixelPosition);
      green = dataView.getUint8(pixelPosition + 1);
      blue = dataView.getUint8(pixelPosition + 2);
      alpha = dataView.getUint8(pixelPosition + 3);
      var pixelPositionInResultArray = (y * width + x) * 4;
      pixels[pixelPositionInResultArray] = red;
      pixels[pixelPositionInResultArray + 1] = green;
      pixels[pixelPositionInResultArray + 2] = blue;
      pixels[pixelPositionInResultArray + 3] = alpha;
    }
  }

  return {
    pixels: pixels,
    width: width,
    height: height,
    bitsPerPixel: bitsPerPixel,
    pixelFormat: pixelFormat
  };
}
/**
 * 
 * @param {ArrayBuffer} dataBuffer Binary data of a compressed bitmap image
 * @returns {{width: number, height: number, pixels: Uint8ClampedArray, bitsPerPixel: number}} Object containing width height and pixel data in rgba form
 */


function parseCompressedImage(dataBuffer) {
  var dataView = new DataView(dataBuffer); // Check signature

  if (dataView.getUint16(0) !== 0x424D) {
    throw new Error("Invalid image signature: ".concat(dataView.getUint16(0).toString(16).padStart(2, '0')));
  } // read header


  var pixelFormat = dataView.getUint16(2, true);
  var width = dataView.getUint16(4, true);
  var height = dataView.getUint16(6, true);
  var rowSize = dataView.getUint16(8, true);
  var bitsPerPixel = dataView.getUint16(10, true);
  var dataSize = dataView.getUint32(12, true);

  if (!([16].includes(bitsPerPixel) && ![0x64].includes(pixelFormat))) {
    throw new Error("Unsuported pixel format/color depth/Palette (should add support) ".concat(pixelFormat.toString(16), " ").concat(bitsPerPixel));
  }

  if (Math.ceil(bitsPerPixel * width / 8) !== rowSize) {
    throw new Error("Row size is not as expected (Padding ?)");
  }

  var offset = HEADER_SIZE; // Read pixel data

  var pixels = new Uint8ClampedArray(4 * width * height);

  while (offset < HEADER_SIZE + dataSize) {
    // read block
    var y = dataView.getUint16(offset, true);
    var x = dataView.getUint16(offset + 2, true);
    var blockSizeInPixels = dataView.getUint16(offset + 4, true);
    offset += 6;

    for (var i = 0; i < blockSizeInPixels; i++) {
      // read pixel color info
      var red = void 0;
      var green = void 0;
      var blue = void 0;
      var alpha = 0x00; // for the 16 bit images, the value is little endian

      var rgba = dataView.getUint16(offset, true); // color is 16bit (5:6:5) rgb

      red = (rgba & 0xF800) >> 8;
      green = (rgba & 0x07E0) >> 3;
      blue = (rgba & 0x001F) << 3;
      var pixelPositionInResultArray = (y * width + x) * 4;
      pixels[pixelPositionInResultArray] = red;
      pixels[pixelPositionInResultArray + 1] = green;
      pixels[pixelPositionInResultArray + 2] = blue; // Alpha is inverted, 0xFF is transparent

      pixels[pixelPositionInResultArray + 3] = 0xFF - alpha;
      offset += 2;
      x++;
    }
  }

  return {
    pixels: pixels,
    width: width,
    height: height,
    bitsPerPixel: bitsPerPixel,
    pixelFormat: pixelFormat
  };
}
/**
 * 
 * @param {Uint8ClampedArray} pixels Pixels data in rgba format
 * @param {number} width 
 * @param {number} height 
 * @returns {ArrayBuffer} The resulting bitmap file data
 */


function writeImage(pixels, width, height) {
  try {
    // attempts 8 bits per pixel indexed image
    return writeImageIndexedColors(pixels, width, height, 8);
  } catch (e) {
    if (e instanceof ImageNotSupportedError) {
      // Default to 24 bits
      return writeImage24Bits(pixels, width, height);
    }

    throw e;
  }
}
/**
 * 
 * @param {Uint8ClampedArray} pixels Pixels data in rgba format
 * @param {number} width 
 * @param {number} height 
 * @returns {ArrayBuffer} The resulting bitmap file data
 */


function writeImage24Bits(pixels, width, height) {
  var bitsPerPixel = 24;
  var bytePerPixel = bitsPerPixel / 8; // Size needed for this image

  var bufferSize = HEADER_SIZE + bitsPerPixel * width * height / 8;
  var buffer = new ArrayBuffer(bufferSize);
  var dataView = new DataView(buffer); // write header

  dataView.setUint8(0, 0x42);
  dataView.setUint8(1, 0x4D);
  dataView.setUint16(2, 0x1B, true);
  dataView.setUint16(4, width, true);
  dataView.setUint16(6, height, true);
  dataView.setUint16(8, width * bitsPerPixel / 8, true);
  dataView.setUint16(10, bitsPerPixel, true);
  dataView.setUint16(12, 0, true);
  dataView.setUint16(14, 0, true); // write pixel data

  for (var i = 0; i < width * height; i++) {
    var red = pixels[i * 4];
    var green = pixels[i * 4 + 1];
    var blue = pixels[i * 4 + 2];
    var alpha = 0xFF - pixels[i * 4 + 3]; // write alpha

    dataView.setUint8(HEADER_SIZE + i * bytePerPixel, alpha); // color is 16bit (5:6:5) bgr

    var rgb = 0;
    rgb |= (blue & 0xF8) << 8;
    rgb |= (green & 0xFC) << 3;
    rgb |= (red & 0xF8) >> 3;
    dataView.setUint16(HEADER_SIZE + i * bytePerPixel + 1, rgb, false);
  }

  return dataView.buffer;
}
/**
 * 
 * @param {Uint8ClampedArray} pixels Pixels data in rgba format
 * @param {number} width 
 * @param {number} height
 * @param {number} bitsPerPixel Should be 1, 2, 4 or 8
 * @returns {ArrayBuffer} The resulting bitmap file data
 */


function writeImageIndexedColors(pixels, width, height, bitsPerPixel) {
  var paletteColorsCount = Math.pow(2, bitsPerPixel);
  var paletteSize = paletteColorsCount * 4; // Size needed for this image

  var bufferSize = HEADER_SIZE + paletteSize + Math.ceil(bitsPerPixel * width * height / 8);
  var buffer = new ArrayBuffer(bufferSize);
  var dataView = new DataView(buffer); // write header

  dataView.setUint8(0, 0x42);
  dataView.setUint8(1, 0x4D);
  dataView.setUint16(2, 0x64, true);
  dataView.setUint16(4, width, true);
  dataView.setUint16(6, height, true);
  dataView.setUint16(8, width * bitsPerPixel / 8, true);
  dataView.setUint16(10, bitsPerPixel, true);
  dataView.setUint16(12, paletteColorsCount, true); // No transparent for now, will be overwritten if needed

  dataView.setUint16(14, 0, true);
  var palette = []; // write pixel data

  var _loop = function _loop(i) {
    var red = pixels[i * 4];
    var green = pixels[i * 4 + 1];
    var blue = pixels[i * 4 + 2];
    var alpha = 0xFF - pixels[i * 4 + 3];
    var color = void 0;

    if (alpha == 0xFF) {
      color = {
        red: 0x00,
        green: 0x00,
        blue: 0x00,
        alpha: alpha
      };
    } else if (alpha == 0x00) {
      color = {
        red: red,
        green: green,
        blue: blue,
        alpha: alpha
      };
    } else {
      throw new ImageNotSupportedError("Alpha cannot be other than visible or not for indexed colors images");
    } // look for color in palette


    var colorIndex = palette.findIndex(function (c) {
      return c.red == color.red && c.blue == color.blue && c.green == color.green && c.alpha == color.alpha;
    });

    if (colorIndex == -1) {
      // Color not found in palette, add it
      colorIndex = palette.length;
      palette.push(color);

      if (palette.length > paletteColorsCount) {
        console.log(palette);
        throw new ImageNotSupportedError("Too many colors in image");
      } // Write actual color in palette


      dataView.setUint8(HEADER_SIZE + colorIndex * 4, red);
      dataView.setUint8(HEADER_SIZE + colorIndex * 4 + 1, green);
      dataView.setUint8(HEADER_SIZE + colorIndex * 4 + 2, blue);

      if (alpha == 0xFF) {
        // Set as transparent color
        dataView.setUint16(14, colorIndex + 1, true);
      }
    } // TODO, for now only supports 8 bit per pixel


    dataView.setUint8(HEADER_SIZE + paletteSize + i, colorIndex);
  };

  for (var i = 0; i < width * height; i++) {
    _loop(i);
  }

  return dataView.buffer;
}

var ImageNotSupportedError = /*#__PURE__*/function (_Error) {
  _inherits(ImageNotSupportedError, _Error);

  var _super = _createSuper(ImageNotSupportedError);

  function ImageNotSupportedError() {
    _classCallCheck(this, ImageNotSupportedError);

    return _super.apply(this, arguments);
  }

  return _createClass(ImageNotSupportedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));